exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-treeview .form-check-input[type=checkbox] + label {\n  padding-left: 24px;\n}\n.custom-treeview li .custom-treeview-node-wrapper.custom-treeview-node-hover:hover {\n  background-color: #deebf7;\n}\n.custom-treeview .custom-treeview-node-wrapper > i > svg {\n  cursor: pointer;\n}\n.custom-treeview .md-icon {\n  min-width: 15px;\n}", ""]);

// exports
